import React from 'react'

const DareGreatly = () => {
	return (
		<div className='converseValues-content'>
			<h1 className='section-title'>DARE GREATLY*</h1>

			<div className='ncss-row' style={{ marginTop: '48px', borderBottom: '1px solid white', paddingBottom: '50px' }}>
				<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm'>
					<p className='section-title' style={{ fontSize: '40px' }}>
						PASSION
					</p>
					<p className='section-p'>
						We are independent enough not to follow. We believe in ourselves and our ideas so strongly, our confidence
						compels us to action. Only we can create the change we seek.
					</p>
				</div>
				<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm'>
					<p className='section-title' style={{ fontSize: '40px' }}>
						HUSTLE
					</p>
					<p className='section-p'>
						We’re competitive, moving quickly and decisively. With change as the only constant in this modern world, evolving
						immediately is how we stay ahead. Agility is our edge.
					</p>
				</div>
				<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm'>
					<p className='section-title' style={{ fontSize: '40px' }}>
						GRIT
					</p>
					<p className='section-p'>
						We are resilient. Learning from every challenge is how we keep moving forward. Our unwillingness to settle is
						relentless and our optimism is contagious.
					</p>
				</div>
			</div>
			<div className='converse-behaviros'>
				<p className='section-title' style={{ marginTop: '50px', marginBottom: '24px', fontSize: '40px' }}>
					Behaviors
				</p>

				<div className='ncss-row' style={{ marginTop: '24px' }}>
					<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm' style={{ verticalAlign: 'top' }}>
						<p className='section-p' style={{ fontSize: '24px' }}>
							I AM A SELF-STARTER!
						</p>
					</div>
					<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm' style={{ verticalAlign: 'top' }}>
						<p className='section-p' style={{ fontSize: '24px' }}>
							I PRIORITIZE WHAT’S MOST IMPORTANT
						</p>
					</div>
					<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm' style={{ verticalAlign: 'top' }}>
						<p className='section-p' style={{ fontSize: '24px' }}>
							I SIMPLIFY AND GO
						</p>
					</div>
				</div>
			</div>
		</div>
	)
}

export default DareGreatly



// WEBPACK FOOTER //
// ./src/containers/AboutPage/ConverseValues/DareGreatly.js